/**
 * BreadcrumbList type
 * DOC: https://schema.org/BreadcrumbList
 */

export const breadcrumbListType = ({
  itemListElement
}) => {
  if (!itemListElement && itemListElement.length <= 0) {
    throw new Error('itemListElement argument is required');
  }
  const listItem = (name, item, index) => `{
    "@type": "ListItem",
    "position": ${index},
    "name": "${name}",
    "item": "${item}"
  }`;
  const result = [];
  result.push('"@context": "https://schema.org"');
  result.push('"@type": "BreadcrumbList"');
  result.push(`"itemListElement": [
    ${itemListElement.map(({
    name,
    item
  }, index) => listItem(name, item, index + 1)).join(',')}
  ]`);
  return `{${result.filter(item => item).join(',')}}`;
};